import {
  SAVE_TASKS,
  SAVE_TASKS_ALL,
  SAVE_ISSUES,
  SAVE_ISSUES_ALL,
  SAVE_GROUPED_TASKS,
  SAVE_DATAPICK_TASKS,
  SAVE_DATAPICK_TASKS_ALL,
  SAVE_INSTALLATION_DOCUMENT_TASKS,
  SAVE_INSTALLATION_DOCUMENT_TASKS_ALL,
  SAVE_GROUPED_TASKS_ALL
} from '../actions/servicereport';


const defaultState = {
  tasks: -1,
  tasksAll: [],
  groupedTasks: -1,
  groupedTasksAll: [],
  issues: -1,
  issuesAll: [],
  datapickTasks: -1,
  datapickTasksAll: [],
  installationDocumentTasks: -1,
  installationDocumentTasksAll: [],
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case SAVE_GROUPED_TASKS: {
      if (action.groupedTasks) {
        return Object.assign({}, state, {
          groupedTasks: action.groupedTasks,
        });
      }
      break;
    }
    case SAVE_GROUPED_TASKS_ALL: {
      if (action.groupedTasksAll) {
        return Object.assign({}, state, {
          groupedTasksAll: action.groupedTasksAll,
        });
      }
      break;
    }
    case SAVE_TASKS: {
      if (action.tasks) {
        return Object.assign({}, state, {
          tasks: action.tasks,
        });
      }
      break;
    }
    case SAVE_TASKS_ALL: {
      if (action.tasksAll) {
        return Object.assign({}, state, {
          tasksAll: action.tasksAll,
        });
      }
      break;
    }
    case SAVE_ISSUES: {
      if (action.issues) {
        return Object.assign({}, state, {
          issues: action.issues,
        });
      }
      break;
    }

    case SAVE_ISSUES_ALL: {
      if (action.issuesAll) {
        return Object.assign({}, state, {
          issuesAll: action.issuesAll,
        });
      }
      break;
    }

    case SAVE_DATAPICK_TASKS: {
      if (action.datapickTasks) {
        return Object.assign({}, state, {
          datapickTasks: action.datapickTasks,
        });
      }
      break;
    }

    case SAVE_DATAPICK_TASKS_ALL: {
      if (action.datapickTasksAll) {
        return Object.assign({}, state, {
          datapickTasksAll: action.datapickTasksAll,
        });
      }
      break;
    }

    case SAVE_INSTALLATION_DOCUMENT_TASKS: {
      if (action.installationDocumentTasks) {
        return Object.assign({}, state, {
          installationDocumentTasks: action.installationDocumentTasks,
        });
      }
      break;
    }

    case SAVE_INSTALLATION_DOCUMENT_TASKS_ALL: {
      if (action.installationDocumentTasksAll) {
        return Object.assign({}, state, {
          installationDocumentTasksAll: action.installationDocumentTasksAll,
        });
      }
      break;
    }

    default:
  }

  return state;
};



// WEBPACK FOOTER //
// ./src/reducers/servicereport.js